module.exports = __webpack_public_path__ + "img/gender_male.7630610b.svg";